export { RecentProjectsComponent } from './recent-projects.component';
export { RecentProjectsService } from './recent-projects.service';



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/shared/layout/header/recent-projects/index.ts